import InventoryLastInventoryLogChart from 'components/charts/e-charts/InventoryLastInventoryLogChart';
import { Card } from 'react-bootstrap';

interface LastInventoryLog {
  all_drills: number;
  completed_drills: number;
  hold_drills: number;
  inprogress_drills: number;
  nonrepairable_drills: number;
}

interface InventoryLastInventoryCardProps {
  lastInventoryLog: LastInventoryLog;
}

const InventoryLastInventoryCard = ({
  lastInventoryLog
}: InventoryLastInventoryCardProps) => {
  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between">
          <div>
            <h5 className="mb-2">Drill inventory </h5>
          </div>
        </div>
        <div className="d-flex justify-content-center pt-3 flex-1">
          <InventoryLastInventoryLogChart lastInventoryLog={lastInventoryLog} />
        </div>
        <div>
          <div className="d-flex align-items-center mb-2">
            <div className="bullet-item bg-primary me-2"></div>
            <h6 className="text-900 fw-semi-bold flex-1 mb-0">
              Completed Drills
            </h6>
            <h6 className="text-900 fw-semi-bold mb-0">
              {lastInventoryLog && lastInventoryLog.completed_drills}
            </h6>
          </div>
          <div className="d-flex align-items-center mb-2">
            <div className="bullet-item bg-primary-200 me-2"></div>
            <h6 className="text-900 fw-semi-bold flex-1 mb-0">Hold Drills</h6>
            <h6 className="text-900 fw-semi-bold mb-0">
              {lastInventoryLog && lastInventoryLog.hold_drills}
            </h6>
          </div>
          <div className="d-flex align-items-center">
            <div className="bullet-item bg-info-500 me-2"></div>
            <h6 className="text-900 fw-semi-bold flex-1 mb-0">
              Inprogress Drills
            </h6>
            <h6 className="text-900 fw-semi-bold mb-0">
              {lastInventoryLog && lastInventoryLog.inprogress_drills}
            </h6>
          </div>
          <div className="d-flex align-items-center">
            <div className="bullet-item bg-info-500 me-2"></div>
            <h6 className="text-900 fw-semi-bold flex-1 mb-0">
              Non repairable Drills
            </h6>
            <h6 className="text-900 fw-semi-bold mb-0">
              {lastInventoryLog && lastInventoryLog.nonrepairable_drills}
            </h6>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default InventoryLastInventoryCard;
